<template>
  <div class="personal-achievement">
    <van-tabs @click="changeTab">
      <van-tab name="day" title="日维度"></van-tab>
      <van-tab name="month" title="月维度"></van-tab>
    </van-tabs>

    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      style="overflow: unset; position: relative; top: 60px"
    >
      <div class="no-found" v-if="!list || list.length == 0">
        <img
          src="https://syfrontweb.oss-cn-hangzhou.aliyuncs.com/wechat/quguo-mina/public/no_data_f.png"
        />
        <div class="case">暂无数据！</div>
      </div>
      <van-list v-else :immediate-check="false" @load="queryList">
        <div
          v-for="(item, index) in list"
          :key="index"
          v-show="item.payDate || item.month"
          class="list"
          :class="index < list.length - 1 ? 'border-bottom' : ''"
        >
          <div class="date" v-if="tabName == 'day'">{{ item.payDate }}</div>
          <div class="date" v-if="tabName == 'month'">
            {{ item.month }}
          </div>

          <div class="items">
            <div class="item">
              <div class="left">新增伙伴</div>
              <div class="right">{{ item.registerCount || 0 }}人</div>
            </div>
            <div class="item">
              <div class="left">新增MPOS商户</div>
              <div class="right">{{ item.allActivateCount || 0 }}户</div>
            </div>
            <div class="item">
              <div class="left">新增收单商户</div>
              <div class="right">{{ item.allWposActiveCount || 0 }}户</div>
            </div>
            <div class="item">
              <div class="left">新增电签商户</div>
              <div class="right">{{ item.allSposActiveCount || 0 }}户</div>
            </div>
            <div class="item">
              <div class="left">新增4G电签商户</div>
              <div class="right">{{ item.all4GSposActiveCount || 0 }}户</div>
            </div>
            <div class="item">
              <div class="left">总交易额</div>
              <div class="right">{{ item.allMoney || 0 | formatMoney }}元</div>
            </div>
            <div class="detail">
              <div class="left">MPOS交易总额</div>
              <div class="right">
                {{ item.allMposMoney || 0 | formatMoney }}元
              </div>
            </div>
            <div class="detail">
              <div class="left">借记卡封顶交易额</div>
              <div class="right">
                {{ item.allCapMoney || 0 | formatMoney }}元
              </div>
            </div>
            <div class="detail">
              <div class="left">借记卡非封顶交易额</div>
              <div class="right">
                {{ item.allWposBankD || 0 | formatMoney }}元
              </div>
            </div>
            <div class="detail">
              <div class="left">POS类贷记卡交易额</div>
              <div class="right">
                {{ item.allWposBankC || 0 | formatMoney }}元
              </div>
            </div>
            <div class="detail">
              <div class="left">扫码类交易额</div>
              <div class="right">{{ item.allScan || 0 | formatMoney }}元</div>
            </div>
            <div class="detail">
              <div class="left">电签交易额</div>
              <div class="right">
                {{ item.allSposMoney || 0 | formatMoney }}元
              </div>
            </div>
            <div class="detail">
              <div class="left">4G电签交易额</div>
              <div class="right">
                {{ item.all4GSposMoney || 0 | formatMoney }}元
              </div>
            </div>
          </div>
        </div>
        <div v-show="finished" class="finished">没有更多了</div>
        <div v-show="!finished" class="load-more" @click="queryList">
          点击加载更多
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import {
  WSBridge,
  platformAgent,
  formatMoney,
  jiemi,
  getParams
} from '@/utils/utils'
import { getgryjday, getgryjmonth } from '@/api/achievement/personal'
export default {
  filters: {
    formatMoney
  },
  data() {
    return {
      list: [],
      content: '',
      pageNo: 1,
      pageSize: 10,
      tabName: 'day',
      loading: false,
      finished: false,
      isFirst: true,
      refreshing: false
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    queryList() {
      if (this.isFirst) {
        this.pageNo = 1
      } else {
        this.pageNo++
      }
      this.loading = true
      if (this.finished) {
        return
      }
      if (this.tabName == 'day') {
        this.getDayList()
      } else if (this.tabName == 'month') {
        this.getMonthList()
      }
      return
      let result = WSBridge.nativeHttpEncrypt({
        params: {
          action:
            this.tabName == 'day'
              ? 'getPersonalPerformanceDay'
              : 'getPersonalPerformanceMonth',
          keyword: '',
          type: 'Mpos',
          pageNo: this.pageNo,
          pageSize: this.pageSize
        },
        success: res => {
          this.getEncryptParams(res)
        }
      })
      if (platformAgent() == 'android') {
        this.getEncryptParams(result)
      }
    },
    // 获取加密参数
    getEncryptParams(result) {
      if (typeof result == 'string') {
        result = JSON.parse(result)
      }
      let headers = result.headers
      if (typeof headers == 'string') {
        headers = JSON.parse(headers)
      }
      this.$store.commit('SET_QUERYS', headers)
      let params = result.body
      if (typeof params == 'string') {
        params = JSON.parse(params)
      }
      let token = result.token
      if (this.tabName == 'day') {
        this.getDayList(params, token)
      } else if (this.tabName == 'month') {
        this.getMonthList(params, token)
      }
    },
    // 获取解密结果
    getDecryptResult(result) {
      result = jiemi(result)
      if (typeof result == 'string') {
        result = JSON.parse(result)
      }
      this.loading = false
      if (result) {
        if (this.isFirst) {
          this.list = []
          this.list = result.data || []
          this.isFirst = false
          if (JSON.stringify(result.data).includes('{}')) {
            this.finished = true
          }
        } else {
          if (result.data && result.data.length > 0) {
            this.list.push(...result.data)
            if (JSON.stringify(result.data).includes('{}')) {
              this.finished = true
            }
          } else {
            this.finished = true
          }
        }
      }
    },
    getDayList() {
      getgryjday({
        action: this.tabName == 'getPersonalPerformanceDay',
        keyword: '',
        type: 'Mpos',
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }).then(result => {
        this.loading = false
        if (result) {
          if (this.isFirst) {
            this.list = []
            this.list = result || []
            this.isFirst = false
            if (JSON.stringify(result).includes('{}')) {
              this.finished = true
            }
          } else {
            if (result && result.length > 0) {
              this.list.push(...result)
              if (JSON.stringify(result).includes('{}')) {
                this.finished = true
              }
            } else {
              this.finished = true
            }
          }
        }
      })
    },
    getMonthList(params, token) {
      getgryjmonth({
        action: 'getPersonalPerformanceMonth',
        keyword: '',
        type: 'Mpos',
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }).then(result => {
        this.loading = false
        if (result) {
          if (this.isFirst) {
            this.list = []
            this.list = result || []
            this.isFirst = false
            if (JSON.stringify(result).includes('{}')) {
              this.finished = true
            }
          } else {
            if (result && result.length > 0) {
              this.list.push(...result)
              if (JSON.stringify(result).includes('{}')) {
                this.finished = true
              }
            } else {
              this.finished = true
            }
          }
        }
      })
    },
    changeTab(e) {
      scrollTo(0, 0)
      this.list = []
      this.tabName = e
      this.isFirst = true
      this.finished = false
      this.queryList()
    },
    onRefresh() {
      this.isFirst = true
      this.finished = false
      this.queryList()
      setTimeout(() => {
        this.refreshing = false
      }, 1000)
    }
  }
}
</script>
